import React, {
  Component
} from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Header,
  Icon,
  List,
  Menu,
  Message,
  Modal,
  Segment
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import { find, isEqual } from 'lodash';
import ItemList from './../lists/ItemList';
import NavPages from './../navigation/NavPages';
import AForm from './AForm';

const INITIAL_STATE = {
  loading: false,
  filters: {
    searchText: ''
  },
  records: [],
  selected: null,
  limit: 5,
  skip: 0,
  total: 0,
  error: null,
  upsertModal: {
    open: false
  },
  removeModal: {
    open: false,
    loading: false,
    id: null,
    error: null
  }
};

class AList extends Component {

  constructor (props) {
    super(props);

    this.state = {
      ...INITIAL_STATE,
      limit: props.pageRange
    };
  }

  componentDidMount () {
    this.fetchRecords();
  }

  componentDidUpdate (prevProps) {
    let {
      serviceParams
    } = this.props.options;
    let prevOptions = prevProps.options;

    if (serviceParams && !isEqual(serviceParams, prevOptions.serviceParams)) {
      this.fetchRecords();
    }
  }

  refreshRecords () {
    this.fetchRecords();
  }

  changeSearchValue (e) {
    this.setState({
      filters: {
        ...this.state.filters,
        searchText: e.target.value
      }
    });
  }

  pageChange (page) {
    let limit = this.props.pageRange;
    let skip = page * this.props.pageRange;

    this.setState({
      skip,
      limit
    }, () => {
      this.fetchRecords();
    });
  }

  fetchRecords () {
    let {
      filters,
      skip,
      limit
    } = this.state;
    let {
      options: {
        serviceParams
      }
    } = this.props;
    let extraParams = {};

    if (serviceParams) {
      extraParams = serviceParams;
    }

    this.setState({
      loading: true,
      records: [],
      total: 0,
      error: null
    }, () => {
      this.props.service.find({
        query: {
          searchText: filters.searchText,
          skip,
          limit,
          ...extraParams
        }
      })
        .then(response => {
          this.setState({
            loading: false,
            records: response.records,
            total: response.total
          });
        })
        .catch(error => {
          this.setState({
            loading: false,
            error: error
          });
        });
    });
  }

  submitSearch (e) {
    e.preventDefault();

    this.fetchRecords();
  }

  selectRecord (record) {
    this.setState({
      selected: find(this.state.records, (r) => r.id === record.id)
    }, () => {
      this.openUpsertModal();
    });
  }

  openUpsertModal () {
    this.setState({
      upsertModal: {
        open: true
      }
    });
  }

  doneSubmiting () {
    this.setState({
      upsertModal: {
        open: false
      },
      selected: null
    });

    toast.success('Operacion Exitosa');

    this.refreshRecords();
  }

  dismissUpsert () {
    this.setState({
      upsertModal: {
        open: false
      },
      selected: null
    });
  }

  openRemoveModal (id) {

    this.setState({
      removeModal: {
        ...this.state.removeModal,
        open: true,
        id: id,
        error: null
      }
    });

  }

  removeRecord () {

    if (this.state.removeModal.id) {
      this.setState({
        removeModal: {
          ...this.state.removeModal,
          loading: true
        }
      }, () => {
        this.props.service.remove(this.state.removeModal.id)
          .then(response => {
            this.setState({
              removeModal: INITIAL_STATE.removeModal
            }, this.refreshRecords());
          })
          .catch(error => {
            this.setState({
              removeModal: {
                ...this.state.removeModal,
                loading: false,
                error: error
              }
            });
          });
      });
    }

  }

  dismissRemove () {
    this.setState({
      removeModal: INITIAL_STATE.removeModal
    });
  }

  render () {
    let {
      loading,
      filters,
      records,
      skip,
      limit,
      selected,
      total,
      upsertModal,
      removeModal
    } = this.state;
    let {
      options
    } = this.props;

    return (
      <div>
        <ToastContainer
          hideProgressBar={true}
          position={toast.POSITION.BOTTOM_RIGHT} />

        <Menu attached="top">
          <Menu.Item icon="refresh" onClick={this.refreshRecords.bind(this)} />

          <Menu.Menu position="right">
            <div className="ui right aligned category search item">
              <form onSubmit={this.submitSearch.bind(this)} className="ui transparent icon input">
                <input
                  className="prompt" type="text" placeholder="Buscar ..."
                  value={filters.searchText} onChange={this.changeSearchValue.bind(this)} />
                <i className="search link icon" />
              </form>
              <div className="results"></div>
            </div>
          </Menu.Menu>
        </Menu>

        <Segment loading={loading} attached>
          <ItemList
            loading={loading}
            data={records.map(this.props.mapFunction)}
            selectItem={options.selectItem || this.selectRecord.bind(this)}
            removeItem={!options.disableRemove ? this.openRemoveModal.bind(this) : null} />
        </Segment>

        <Segment clearing attached="bottom">
          {
            this.props.form &&
              <Button primary content="Nuevo" icon="add" onClick={this.openUpsertModal.bind(this)} />
          }
          <NavPages
            floated="right" pageChange={this.pageChange.bind(this)}
            selected={skip / this.props.pageRange} itemsPerPage={this.props.pageRange} total={total} />
        </Segment>

        {
          !options.disableRemove &&
            <Modal
              dimmer="blurring" basic size="small"
              open={removeModal.open} onClose={this.dismissRemove.bind(this)}>
              <Header icon="trash" content="Eliminar registro" />
              <Modal.Content>
                <p>Seguro desea eliminar este registro?</p>
                {
                  removeModal.error &&
                    <Message negative>
                      <Message.Header>Error! {removeModal.error.message}</Message.Header>
                      <p>
                        {removeModal.error.name}
                      </p>
                    </Message>
                }
              </Modal.Content>
              <Modal.Actions>
                <Button
                  basic color="red" inverted
                  disabled={removeModal.loading} onClick={this.dismissRemove.bind(this)}>
                  <Icon name="remove" /> No
                </Button>
                <Button color="green" inverted disabled={removeModal.loading} onClick={this.removeRecord.bind(this)}>
                  <Icon name="checkmark" /> {removeModal.loading ? 'Procesando...' : 'Si'}
                </Button>
              </Modal.Actions>
            </Modal>
        }

        {
          this.props.form &&
            <Modal
              dimmer="blurring" size="small"
              open={upsertModal.open} onClose={this.dismissUpsert.bind(this)}>
              <Header icon="edit" content="Formulario de registro" />
              <Modal.Content>
                {
                  typeof this.props.form === 'object' ?
                    <AForm
                      fields={this.props.form.fields}
                      record={selected}
                      service={this.props.form.service}
                      options={this.props.form.options}
                      dismiss={this.dismissUpsert.bind(this)}
                      doneSubmiting={this.doneSubmiting.bind(this)} /> : null
                }
              </Modal.Content>
            </Modal>
        }

      </div>
    );
  }
}

AList.propTypes = {
  form: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.shape({
      header: PropTypes.string,
      fields: PropTypes.arrayOf(PropTypes.array).isRequired
    })
  ]),
  mapFunction: PropTypes.func.isRequired,
  options: PropTypes.shape({
    disableRemove: PropTypes.bool,
    selectItem: PropTypes.func,
    serviceParams: PropTypes.object
  }),
  pageRange: PropTypes.number,
  service: PropTypes.shape({
    find: PropTypes.func.isRequired,
    create: PropTypes.func.isRequired,
    update: PropTypes.func.isRequired,
    patch: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired
  }).isRequired
};

AList.defaultProps = {
  pageRange: 10,
  options: {
    disableRemove: false,
    selectItem: null,
    serviceParams: null
  }
};

export default AList;



// WEBPACK FOOTER //
// ./client/components/auto/AList.js